"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/select/style/css");

var _select = _interopRequireDefault(require("antd/es/select"));

require("antd/es/popover/style/css");

var _popover = _interopRequireDefault(require("antd/es/popover"));

require("antd/es/input-number/style/css");

var _inputNumber = _interopRequireDefault(require("antd/es/input-number"));

require("antd/es/input/style/css");

var _input = _interopRequireDefault(require("antd/es/input"));

require("antd/es/modal/style/css");

var _modal = _interopRequireDefault(require("antd/es/modal"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var selectors = _interopRequireWildcard(require("../../redux/selectors"));

var _reselect = require("reselect");

require("./badge.scss");

var _reactRouter = require("react-router");

var _form = _interopRequireDefault(require("antd/es/form"));

var _badges = require("../../redux/badges/badges.types");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const {
  confirm
} = _modal.default;
const initialState = {
  label: '',
  description: '',
  image: '',
  quota: 0,
  type: '',
  sequence: 0,
  badgeCollectionGroupId: -1,
  meta: '',
  error: ''
};

class AddBadgeCollectionModal extends _react.Component {
  constructor() {
    super(...arguments);
    this.state = initialState;
    this.form = /*#__PURE__*/_react.default.createRef();

    this.handleBadgeCollectionGroupChange = badgeCollectionGroupId => {
      this.setState({
        badgeCollectionGroupId
      });
    };

    this.handleBadgeChange = async e => {
      const file = e.target.files[0];
      const image = await this.convertBase64(file);
      this.setState({
        image
      });
    };

    this.hide = () => {
      this.setState({
        image: ''
      });
      this.props.hide();
    };

    this.convertBase64 = file => {
      return new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.readAsDataURL(file);

        fileReader.onload = () => {
          resolve(fileReader.result);
        };

        fileReader.onerror = error => {
          reject(error);
        };
      });
    };

    this.onFinish = values => {
      var _a;

      const {
        image
      } = this.state;

      if ((_a = this.props.badgeCollection) === null || _a === void 0 ? void 0 : _a.id) {
        Object.assign(values, {
          id: this.props.badgeCollection.id
        });
      }

      Object.assign(values, {
        badge: image
      });
      this.props.saveBadgeCollection(values);
      this.hide();
    };

    this.normFile = e => {
      if (Array.isArray(e)) {
        return e;
      }

      return e && e.fileList;
    };

    this.validateImage = (_, value) => {
      const {
        image
      } = this.state;

      if (image) {
        return Promise.resolve();
      }

      return Promise.reject(new Error('Upload an image for the badge'));
    };

    this.handleOk = () => {
      var _a;

      if ((_a = this.form) === null || _a === void 0 ? void 0 : _a.current) {
        this.form.current.validateFields().then(() => {
          confirm({
            title: 'Are you sure you want to create this badge collection?',
            content: '',
            okText: 'Confirm',
            onOk: () => {
              var _a;

              this.onFinish((_a = this.form.current) === null || _a === void 0 ? void 0 : _a.getFieldsValue());
            },

            onCancel() {}

          });
        });
      }
    };

    this.handleCancel = () => {
      confirm({
        title: 'Are you sure you want to leave this badge collection?',
        content: 'You will lose all changes',
        okText: 'Leave',
        okType: 'danger',
        onOk: () => {
          this.hide();
        },

        onCancel() {}

      });
    };
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    var _a, _b;

    if (((_a = prevProps.badgeCollection) === null || _a === void 0 ? void 0 : _a.id) !== ((_b = this.props.badgeCollection) === null || _b === void 0 ? void 0 : _b.id)) {
      if (this.props.badgeCollection) {
        this.setState({
          label: this.props.badgeCollection.label,
          description: this.props.badgeCollection.description,
          sequence: this.props.badgeCollection.sequence,
          badgeCollectionGroupId: this.props.badgeCollection.badgeCollectionGroupId
        });
      } else {
        this.setState({
          label: '',
          description: '',
          sequence: 0,
          badgeCollectionGroupId: -1
        });
      }
    }
  }

  render() {
    const {
      visible,
      badgeCollectionTypes,
      badgeCollection,
      badgeGroups
    } = this.props;
    const {
      label,
      description,
      quota,
      image,
      type,
      sequence,
      badgeCollectionGroupId,
      meta,
      error
    } = this.state;
    const badgeCollectionTypeOptions = (badgeCollectionTypes || []).map(b => {
      return {
        value: b.id,
        label: b.label
      };
    });
    const badgeCollectionGroupOptions = (badgeGroups || []).map(b => {
      return {
        value: b.id,
        label: b.label
      };
    });
    return /*#__PURE__*/_react.default.createElement(_modal.default, {
      className: "add-badge-modal",
      title: "Add Badge Collection",
      width: "45%",
      visible: visible,
      onOk: this.handleOk,
      onCancel: this.handleCancel,
      destroyOnClose: true
    }, /*#__PURE__*/_react.default.createElement(_form.default, {
      ref: this.form,
      key: "form",
      initialValues: badgeCollection,
      onFinish: this.onFinish
    }, /*#__PURE__*/_react.default.createElement(_form.default.Item, {
      label: "Label",
      name: "label",
      rules: [{
        required: true
      }]
    }, /*#__PURE__*/_react.default.createElement(_input.default, {
      placeholder: "This is the label the user's will see on the badge"
    })), /*#__PURE__*/_react.default.createElement(_form.default.Item, {
      label: "Description",
      name: "description",
      rules: [{
        required: true
      }]
    }, /*#__PURE__*/_react.default.createElement(_input.default, {
      placeholder: "This is the Description the user's will see on the badge"
    })), /*#__PURE__*/_react.default.createElement(_form.default.Item, {
      label: "Sequence",
      name: "sequence",
      rules: [{
        required: true
      }]
    }, /*#__PURE__*/_react.default.createElement(_inputNumber.default, null)), /*#__PURE__*/_react.default.createElement(_form.default.Item, {
      label: "Image",
      name: "image",
      getValueFromEvent: this.normFile,
      validateTrigger: "onSubmit",
      rules: [{
        required: true,
        validator: this.validateImage
      }]
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "form-row"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "input"
    }, image ? /*#__PURE__*/_react.default.createElement(_popover.default, {
      style: {
        width: '100px'
      },
      placement: "right",
      content: /*#__PURE__*/_react.default.createElement("img", {
        src: image
      })
    }, /*#__PURE__*/_react.default.createElement("img", {
      style: {
        height: '100px'
      },
      src: image
    })) : /*#__PURE__*/_react.default.createElement(_input.default, {
      ref: "file",
      type: "file",
      name: "file",
      className: "upload-file",
      id: "file",
      onChange: this.handleBadgeChange,
      encType: "multipart/form-data"
    })))), /*#__PURE__*/_react.default.createElement(_form.default.Item, {
      label: "Quota",
      name: "quota",
      rules: [{
        required: true
      }]
    }, /*#__PURE__*/_react.default.createElement(_inputNumber.default, null)), /*#__PURE__*/_react.default.createElement(_form.default.Item, {
      label: "Type",
      name: "badgeCollectionTypeId",
      rules: [{
        required: true
      }]
    }, /*#__PURE__*/_react.default.createElement(_select.default, {
      placeholder: "Select a type",
      options: badgeCollectionTypeOptions
    })), /*#__PURE__*/_react.default.createElement(_form.default.Item, {
      label: "Group",
      name: "badgeCollectionGroupId"
    }, /*#__PURE__*/_react.default.createElement(_select.default, {
      placeholder: "Select a group (not required)",
      options: badgeCollectionGroupOptions
    })), /*#__PURE__*/_react.default.createElement(_form.default.Item, {
      label: "Meta",
      name: "meta"
    }, /*#__PURE__*/_react.default.createElement(_input.default, {
      placeholder: "Use with caution"
    }))));
  }

}

const mapStateToProps = (0, _reselect.createStructuredSelector)({
  studyId: selectors.getRequestedStudyId,
  badges: selectors.getBadges,
  badgeGroups: selectors.getBadgeGroups,
  badgeCollectionTypes: selectors.getBadgeCollectionTypes,
  badgeCollection: selectors.getRequestedBadgeCollection
});

const mapDispatchToProps = dispatch => {
  return {
    saveBadgeCollection: badgeCollection => dispatch(_badges.saveBadgeCollectionAsync.request(badgeCollection))
  };
};

var _default = (0, _reactRouter.withRouter)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AddBadgeCollectionModal));

exports.default = _default;